import {Observable} from "rxjs";
import {DeepLink} from "@app/core/shared/domain/entities/deep-link";


export abstract class DeepLinkService {
    /**
     * Emits a DeepLink when the app receives a deep link.
     */
    abstract getDeepLink(): Observable<DeepLink>;
}
